import { useIntl } from 'react-intl';

interface IInfoTooltip {
  alarm: number | string;
  waypoint: number | string;
  event: number | string;
  comment: number;
  tag: number;
  datacyIndex: number;
}

function InfoTooltip(props: IInfoTooltip): JSX.Element {
  const { formatMessage: f } = useIntl();

  const getWaypointTraslate = (count: number | string) => {
    if (typeof count === 'string') {
      return f({ id: 'rides.info.waypoints' });
    }
    if (count > 4 || count === 0) {
      return f({ id: 'rides.info.waypointAcc' });
    }
    if (count > 1) {
      return f({ id: 'rides.info.waypoints' });
    }
    return f({ id: 'rides.info.waypoint' });
  };

  const getEventTraslate = (count: number | string) => {
    if (typeof count === 'string') {
      return f({ id: 'rides.info.events' });
    }
    if (count > 4 || count === 0) {
      return f({ id: 'rides.info.eventAcc' });
    }
    if (count > 1) {
      return f({ id: 'rides.info.events' });
    }
    return f({ id: 'rides.info.event' });
  };

  const getAlarmTraslate = (count: number | string) => {
    if (typeof count === 'string') {
      return f({ id: 'rides.info.alarms' });
    }
    if (count > 4 || count === 0) {
      return f({ id: 'rides.info.alarmAcc' });
    }
    if (count > 1) {
      return f({ id: 'rides.info.alarms' });
    }
    return f({ id: 'rides.info.alarm' });
  };

  const getPurposeTraslate = (count: number) => {
    if (count > 4 || count === 0) {
      return f({ id: 'rides.info.purposeAcc' });
    }
    if (count > 1) {
      return f({ id: 'rides.info.purposes' });
    }
    return f({ id: 'rides.info.purpose' });
  };

  const getCommentTraslate = (count: number) => {
    if (count === 0) {
      return f({ id: 'rides.info.noComment' });
    }
    return f({ id: 'rides.info.withComment' });
  };

  return (
    <div key="infoForRideTooltip">
      <div
        data-cy={`row-${props.datacyIndex + 1}-info_Waypoint-tooltip`}
        style={{ color: '#CCF9F0', paddingBottom: '12px', whiteSpace: 'nowrap' }}
      >
        <i
          style={{ color: '#77E4CD', paddingRight: '9px' }}
          className="cmd-icons cmd-icon-waypoint fs-4"
        />
        <span className="w-100 text-truncate align-middle">
          {typeof props.waypoint === 'string' ? <>&ndash;</> : props.waypoint}{' '}
          {getWaypointTraslate(props.waypoint)}
        </span>
      </div>
      <div
        data-cy={`row-${props.datacyIndex + 1}-info_Event-tooltip`}
        style={{ color: '#C8BEEE', paddingBottom: '12px', whiteSpace: 'nowrap' }}
      >
        <i
          style={{ color: '#C8BEEE', paddingRight: '9px' }}
          className="cmd-icons cmd-icon-event fs-4"
        />
        <span className="w-100 text-truncate align-middle">
          {typeof props.event === 'string' ? <>&ndash;</> : props.event}{' '}
          {getEventTraslate(props.event)}
        </span>
      </div>
      <div
        data-cy={`row-${props.datacyIndex + 1}-info_Alarm-tooltip`}
        style={{ color: '#FCD4DF', paddingBottom: '12px', whiteSpace: 'nowrap' }}
      >
        <i
          style={{ color: '#DD6486', paddingRight: '9px' }}
          className="cmd-icons cmd-icon-alarm fs-4"
        />
        <span className="w-100 text-truncate align-middle">
          {typeof props.alarm === 'string' ? <>&ndash;</> : props.alarm}{' '}
          {getAlarmTraslate(props.alarm)}
        </span>
      </div>
      <div
        data-cy={`row-${props.datacyIndex + 1}-info_Tag-tooltip`}
        style={{ color: '#FCDFC8', paddingBottom: '12px', whiteSpace: 'nowrap' }}
      >
        <i
          style={{ color: '#FCDFC8', paddingRight: '11px' }}
          className="cmd-icons cmd-icon-single-folded-content fs-4"
        />
        <span className="w-100 text-truncate align-middle">
          {props.tag} {getPurposeTraslate(props.tag)}
        </span>
      </div>
      <div
        data-cy={`row-${props.datacyIndex + 1}-info_Comment-tooltip`}
        style={{ color: '#D2E2FD', paddingBottom: '0px', whiteSpace: 'nowrap' }}
      >
        <i
          style={{ color: '#9ABAEE', paddingRight: '9px' }}
          className="cmd-icons cmd-icon-commentary fs-4"
        />
        <span className="w-100 text-truncate align-middle">
          {getCommentTraslate(props.comment)}
        </span>
      </div>
    </div>
  );
}

export default InfoTooltip;
